export default "__VITE_PUBLIC_ASSET__16483d7b__"